import { ESocketActionTypes } from './types';
import { actionGenerator } from '../../utils/redux/actionGenerator';

export const setSocketPending = actionGenerator<ESocketActionTypes.Pending>(ESocketActionTypes.Pending);

export const setSocketSucceed = actionGenerator<ESocketActionTypes.Succeed>(ESocketActionTypes.Succeed);

export const setSocketFailed = actionGenerator<ESocketActionTypes.Failed>(ESocketActionTypes.Failed);
